import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { inputCls } from "../site/formPrimitives";
import { Plus, Pencil, Trash2, X, Save, Star } from "lucide-react";

const blank = { author: "", text: "", rating: 5, order: 0, published: true };

export default function ReviewsAdmin() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/admin/reviews").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!edit.author.trim() || !edit.text.trim()) { toast.error("Navn og tekst kreves"); return; }
    if (edit.id) await api.put(`/admin/reviews/${edit.id}`, edit);
    else await api.post("/admin/reviews", edit);
    toast.success("Lagret"); setEdit(null); load();
  };
  const remove = async (id) => {
    if (!window.confirm("Slette anmeldelsen?")) return;
    await api.delete(`/admin/reviews/${id}`); toast.success("Slettet"); load();
  };

  return (
    <div data-testid="admin-reviews">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold text-navy">Anmeldelser</h1>
          <p className="mt-1 text-sm text-ink/60">Legg til ekte kundeanmeldelser. Ingen er publisert som standard.</p>
        </div>
        <button onClick={() => setEdit({ ...blank, order: rows.length + 1 })} className="inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-navy-800" data-testid="review-add"><Plus className="h-4 w-4" /> Legg til</button>
      </div>

      <div className="mt-6 space-y-3">
        {rows.length === 0 && <p className="text-ink/50 text-sm">Ingen anmeldelser lagt inn.</p>}
        {rows.map((r) => (
          <div key={r.id} className="rounded-xl border border-hairline bg-white p-4 shadow-sm flex items-start justify-between gap-4" data-testid={`review-item-${r.id}`}>
            <div>
              <div className="flex items-center gap-2">
                <p className="font-semibold text-navy">{r.author}</p>
                <span className="flex gap-0.5">{Array.from({ length: r.rating }).map((_, k) => <Star key={k} className="h-3.5 w-3.5 fill-warm text-warm" />)}</span>
                {!r.published && <span className="rounded bg-slate-100 px-2 py-0.5 text-xs text-ink/50">Skjult</span>}
              </div>
              <p className="mt-1 text-sm text-ink/70">{r.text}</p>
            </div>
            <div className="flex gap-1 shrink-0">
              <button onClick={() => setEdit(r)} className="p-2 text-ink/50 hover:text-electric" data-testid="review-edit"><Pencil className="h-4 w-4" /></button>
              <button onClick={() => remove(r.id)} className="p-2 text-ink/50 hover:text-red-600" data-testid="review-delete"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>

      {edit && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-navy/60" onClick={() => setEdit(null)} />
          <div className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-xl font-bold text-navy">{edit.id ? "Rediger" : "Ny"} anmeldelse</h3>
              <button onClick={() => setEdit(null)}><X className="h-5 w-5 text-ink/50" /></button>
            </div>
            <div className="space-y-3">
              <input className={inputCls} placeholder="Kundenavn" value={edit.author} onChange={(e) => setEdit({ ...edit, author: e.target.value })} data-testid="review-author-input" />
              <textarea rows={3} className={`${inputCls} resize-none`} placeholder="Anmeldelsestekst" value={edit.text} onChange={(e) => setEdit({ ...edit, text: e.target.value })} data-testid="review-text-input" />
              <div className="flex items-center gap-3">
                <label className="text-sm text-navy">Rangering</label>
                <select className={inputCls} value={edit.rating} onChange={(e) => setEdit({ ...edit, rating: Number(e.target.value) })}>
                  {[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} stjerner</option>)}
                </select>
              </div>
              <label className="flex items-center gap-2 text-sm text-navy">
                <input type="checkbox" className="h-4 w-4 accent-electric" checked={edit.published} onChange={(e) => setEdit({ ...edit, published: e.target.checked })} data-testid="review-published-input" />
                Publiser på nettstedet
              </label>
            </div>
            <button onClick={save} className="mt-5 w-full inline-flex items-center justify-center gap-2 rounded-full bg-warm px-5 py-3 text-sm font-semibold text-navy hover:bg-warm-dark" data-testid="review-save"><Save className="h-4 w-4" /> Lagre</button>
          </div>
        </div>
      )}
    </div>
  );
}
